export default __webpack_public_path__ + "static/media/balcony.c4ba43cf.svg";